import script from "./basic_info.vue?vue&type=script&setup=true&lang=js"
export * from "./basic_info.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__